import { render, staticRenderFns } from "./TopPostsByInteractions.vue?vue&type=template&id=6b54275c&"
import script from "./TopPostsByInteractions.vue?vue&type=script&lang=js&"
export * from "./TopPostsByInteractions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports